// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  extractKey: __t.string().primaryKey().name("extract_key"),
  campaignId: __t.u64().name("campaign_id"),
  rosterKey: __t.string().name("roster_key"),
  side: __t.u8(),
  cls: __t.string(),
  slot: __t.u32(),
  opId: __t.u64().name("op_id"),
  pilot: __t.identity(),
  state: __t.string(),
  sx: __t.f64(),
  sy: __t.f64(),
  sz: __t.f64(),
  rx: __t.f64(),
  ry: __t.f64(),
  rz: __t.f64(),
  startS: __t.f64().name("start_s"),
  arriveS: __t.f64().name("arrive_s"),
  dwellMs: __t.u32().name("dwell_ms"),
  withdrawnAt: __t.timestamp().name("withdrawn_at"),
  returnHulls: __t.u32().name("return_hulls"),
  cancelledShots: __t.u32().name("cancelled_shots"),
  cause: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
